export enum ThemeType {
  Tix = "tix",
  Vliegtickets = "vtnl",
  GVT = "gvt",
  BDA = "bda",
}
